import { render, staticRenderFns } from "./ComponentMatterBalanceSummery.vue?vue&type=template&id=0e852c5c"
import script from "./ComponentMatterBalanceSummery.vue?vue&type=script&lang=js"
export * from "./ComponentMatterBalanceSummery.vue?vue&type=script&lang=js"
import style0 from "./ComponentMatterBalanceSummery.vue?vue&type=style&index=0&id=0e852c5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports